var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12c0 6.629-5.371 12-12 12-1.239 0-2.429-.189-3.552-.537.49-.799 1.22-2.105 1.49-3.145l.746-2.855c.392.745 1.534 1.379 2.748 1.379 3.62 0 6.228-3.33 6.228-7.466 0-3.963-3.237-6.93-7.399-6.93-5.177 0-7.93 3.475-7.93 7.264 0 1.761.938 3.953 2.434 4.65.227.106.348.058.401-.16.039-.165.242-.982.334-1.36a.36.36 0 0 0-.082-.343c-.489-.605-.886-1.708-.886-2.739 0-2.647 2.003-5.206 5.42-5.206 2.946 0 5.013 2.008 5.013 4.882 0 3.247-1.64 5.497-3.775 5.497-1.175 0-2.061-.973-1.775-2.168.338-1.428.992-2.966.992-3.997 0-.92-.494-1.689-1.52-1.689-1.205 0-2.172 1.244-2.172 2.913 0 1.065.358 1.781.358 1.781s-1.186 5.023-1.404 5.961c-.242 1.036-.145 2.497-.043 3.445C3.165 21.431 0 17.086 0 12 0 5.371 5.371 0 12 0s12 5.371 12 12Z",
    fill: "#25282D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.a4cfc77151d8fbd786258e4cc97de2fa.svg";
export { ForwardRef as ReactComponent };